import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faChevronDown, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faRobot, faCoins,faEye, faMicrochip, faBrain,faLaptopCode,faShieldAlt,faPuzzlePiece,
    faFileAlt,
    faTv,
    faChartLine,
    faVial,
    faCubes,
    faFilePowerpoint,
    faChartPie,
    faVideo,faBalanceScale,faIdCard, faMask, faDumbbell, faChalkboardTeacher,faUtensils } from '@fortawesome/free-solid-svg-icons'

// Add it to the library
library.add(faRobot, faCoins, faEye, faMicrochip, faBrain,faShieldAlt,faPuzzlePiece,
    faLaptopCode,
    faFileAlt,
    faTv,
    faChartLine,
    faVial,
    faCubes,
    faFilePowerpoint,
    faChartPie,
    faVideo,faBalanceScale,faIdCard, faMask, faDumbbell, faChalkboardTeacher,faUtensils )


library.add(faBars, faChevronDown, faArrowLeft, faFacebook, faTwitter)